export const EMPTY_ARRAY: unknown[] = [];
Object.freeze(EMPTY_ARRAY);

export const EMPTY_OBJ = {};
Object.freeze(EMPTY_OBJ);

// Keyboard keys
export const KEYS = {
  UP_KEY: {
    // Key values from KeyboardEvent.key (https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values)
    name: 'ArrowUp',
    // Key code value (https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode)
    value: 38,
    // Indicates whether the Shift key also had to be pressed, e.g. when typing a '?' (question mark)
    shiftRequired: false,
    // Alternative key values (NOT key code values) used by older browser versions
    // (E.g. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#Navigation_keys)
    alternatives: ['Up'],
  },
  DOWN_KEY: {
    name: 'ArrowDown',
    value: 40,
    shiftRequired: false,
    alternatives: ['Down'],
  },
  TAB_KEY: {
    name: 'Tab',
    value: 9,
    shiftRequired: false,
  },
  ENTER_KEY: {
    name: 'Enter',
    value: 13,
    shiftRequired: false,
  },
  BACKSPACE_KEY: {
    name: 'Backspace',
    value: 8,
    shiftRequired: false,
  },
  ESC_KEY: {
    name: 'Escape',
    value: 27,
    shiftRequired: false,
    alternatives: ['Esc'],
  },
  SPACE_KEY: {
    name: ' ',
    value: 32,
    shiftRequired: false,
    alternatives: ['Spacebar'],
  },
  EQUAL_KEY: {
    name: '=',
    value: 187,
    shiftRequired: false,
  },
  LESS_THAN_KEY: {
    name: '<',
    value: 188,
    shiftRequired: true,
  },
  GREATER_THAN_KEY: {
    name: '>',
    value: 190,
    shiftRequired: true,
  },
  HASH_KEY: {
    name: '#',
    value: 51,
    shiftRequired: true,
  },
  COMMA_KEY: {
    name: ',',
    value: 188,
    shiftRequired: false,
  },
  SEMICOLON_KEY: {
    name: ';',
    value: 186,
    shiftRequired: false,
  },
};

export const START_OF_DAY = '00:00';
export const END_OF_DAY = '23:59';
export const FULL_DAY_PERIOD = {
  start: START_OF_DAY,
  end: END_OF_DAY,
};

export const MODAL_CONTENT_TYPE = {
  TABLE: 'table',
  EVENT_PLAYER: 'event-player',
  SAVE_PANEL: 'save-panel',
  SNAPSHOT: 'snapshot',
};

export const CHROME_QNAP = 'Chrome/QNAP';
export const REGEX_ILLEGAL_CHARACTERS = /[-[\]{}()*+?.,\\^$|#\s]/g;
export const REGEX_RESERVED_CHARACTERS = /[[\]{}()*+?.\\/^$|]/g;
